'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context,
        $filterBlock = context.find('[data-binding="filter-block"]'),
        $filterItems = context.find('[data-binding="filterable"]');

    function urlify(Text) {
        // 'urlify' taken from here: http://stackoverflow.com/questions/1053902/how-to-convert-a-title-to-a-url-slug-in-jquery
        // so we can use category titles and filter name as form field attributes
        return Text.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
    }

    function sortArray(array) {
        // filter out duplicate names, and sort alphabetically
        return array.slice().sort(function (a, b) {
            return a > b;
        }).reduce(function (a, b) {
            if (a.slice(-1)[0] !== b) a.push(b);
            return a;
        }, []);
    }

    function buildFilter() {
        var filterCategories = [],
            filterName = context.attr('data-filtername'),
            filterNameurlified = urlify(filterName),
            $filterCategoryItems = '<div class="feed-block__filter__option" data-binding="filter-item"><input id="filter-all" name="' + filterNameurlified + '" type="radio" checked data-filter-option="all"><label for="filter-all">All</label></div>',
            uniqueCats;

        // add each filter category to array
        $filterItems.each(function () {

            var filters = $(this).attr('data-filters');

            if (filters !== '') {
                // split items at comma if there is one and add all results to array
                if (filters.indexOf(',') > -1) {
                    filters = filters.split(',');
                    for (var i = 0; i < filters.length; i++) {
                        filterCategories.push(filters[i]);
                    }
                } else {
                    filterCategories.push(filters);
                }
            }
        });

        uniqueCats = sortArray(filterCategories);

        // loop through category array and add radio button to $filterCategoryItems var
        for (var i = 0; i < uniqueCats.length; i++) {
            var catname = uniqueCats[i],
                catnameurlified = urlify(catname);

            $filterCategoryItems += '<div class="feed-block__filter__option" data-binding="filter-item" data-catname="' + catnameurlified + '"><input id="' + catnameurlified + '" name="' + filterNameurlified + '" type="radio" data-filter-option="all"><label for="' + catnameurlified + '">' + catname + '</label></div>';
        }

        // add filter title/label and form items
        $filterBlock.append('<label class="feed-block__filter__label">' + filterName + '</label>');
        $filterBlock.append($filterCategoryItems);
    }

    function filterItems() {
        $filterBlock.on('change', ':input', function () {
            var selectedCat = $(this).next().text();

            if (selectedCat === 'All') {

                $filterItems.show();
            } else {

                $filterItems.each(function () {
                    var $this = $(this),
                        dataFilters = $this.attr('data-filters');

                    if (~dataFilters.indexOf(selectedCat)) {
                        $this.show();
                    } else {
                        $this.hide();
                    }
                });
            }
        });
    }

    function init() {

        buildFilter();
        filterItems();
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/feed-filter.js
// module id = 280
// module chunks = 0